export const homePath = activeDictionaryName => `${activeDictionaryName ? `/${activeDictionaryName}` : '/'}`
export const homePathSegment = () => '/:activeDictionaryName?'
